import React, { Component } from 'react';
import './style/App.css';
import 'semantic-ui-css/semantic.min.css';
import HeaderMenu from './HeaderMenu';
import "animate.css/animate.min.css";
import Footer from './components/Footer.js';
import  Page  from './components/Page';
import config from './config';
import {isValidArr} from './utils'

const renderPages = () => {
  return config.website.pages.map(p => {
    return (<Page {...p}/>);
  });
}
class App extends Component {

  render() {
    const options = [];
    const {pages} = config.website;
    if(isValidArr(pages)){
      pages.forEach(p => {
        if(p.link){
            options.push({ 
            text: p.title,
            icon: p.icon,
            onClick: (e)=>{ window.open(`#${p.link}`, '_self')}
          });
        }
      })
    }
    return (
      <div className="App" style={config.website.style}>
        <HeaderMenu menuItems={options} title={config.website.title}/>        
        {/* <div className='page'>   */}
          {renderPages()}
        {/* </div> */}
        <Footer items={options}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js